<template>
  <ion-app>
    <div id="orderHistory">
      <div xclass="header">
        <div class="van-hairline--bottom background_color_d6f1ec van-nav-bar font_weight_bold" style="z-index: 1;">
          <div class="van-nav-bar__left">
            <i class="van-icon van-icon-arrow-left van-nav-bar__arrow" style="color: #000000 !important;" @click="$router.back(-1)"></i>
          </div>
          <div class="van-ellipsis van-nav-bar__title">{{ $t("member.orderHistory") }}</div>
        </div>
      </div>
    </div>

    <div class="content2">
      <van-row>
        <van-col class="order" v-for="(order, index) in orders" :key="index">
          <div class="order-box">
            <van-row class="order-header" type="flex">
              <van-col>Order Id : {{ order.OrderId }}</van-col>
              <van-col style="text-align: right; flex: 1 1 auto;">Time : {{ timestampToLocaleString(order.OrderStamp) }}</van-col>
            </van-row>

            <van-row class="order-product" v-for="(product, index) in order.Products" :key="index">
              <van-col class="product-qty" span="4">{{ product.OrderQty }}</van-col>
              <van-col class="product-title" span="14">{{ product.Title }}</van-col>
              <van-col class="product-ext" span="6">{{ product.Extension | currency }}</van-col>
            </van-row>

            <div class="order-total">
              <van-row class="subtotal">
                <van-col class="t-title" span="18">{{ $t("order.subtotal") }}</van-col>
                <van-col class="t-value" span="6">{{ order.Subtotal | currency }}</van-col>
              </van-row>

              <van-row class="freight">
                <van-col class="t-title" span="18">{{ $t("order.freight") }}</van-col>
                <van-col class="t-value" span="6">{{ order.Freight | currency }}</van-col>
              </van-row>

              <van-row class="handling" v-show="order.Handling != 0">
                <van-col class="t-title" span="18">{{ $t("order.handling") }}</van-col>
                <van-col class="t-value" span="6">{{ order.Handling | currency }}</van-col>
              </van-row>

              <van-row class="gst">
                <van-col class="t-title" span="18">{{ $t("order.gst") }}</van-col>
                <van-col class="t-value" span="6">{{ order.GSTax | currency }}</van-col>
              </van-row>

              <van-row class="pst">
                <van-col class="t-title" span="18">{{ $t("order.pst") }}</van-col>
                <van-col class="t-value" span="6">{{ order.PSTax | currency }}</van-col>
              </van-row>

              <van-row class="total">
                <van-col class="t-title" span="18">{{ $t("order.total") }}</van-col>
                <van-col class="t-value" span="6">{{ order.Total | currency }}</van-col>
              </van-row>
            </div>

            <div class="order-shipping">
              <van-row class="shipto-title">{{ $t("order.shipto") }}</van-row>
              <div class="ship-to-address" v-if="order.ShipToInfo.storeId !== undefined">
                <van-row v-show="order.ShipToInfo.address != ''">{{ order.ShipToInfo.address }}</van-row>
                <van-row v-show="order.ShipToInfo.city != '' && order.ShipToInfo.postal != ''"
                  >{{ order.ShipToInfo.city }} {{ order.ShipToInfo.postal }}</van-row
                >
                <van-row v-show="order.ShipToInfo.phone != ''">{{ order.ShipToInfo.phone }}</van-row>
              </div>
              <div class="ship-to-address" v-else>
                <van-row v-show="order.ShipToInfo.AddrName != ''">{{ order.ShipToInfo.AddrName }}</van-row>
                <van-row v-show="order.ShipToInfo.AddrDescription != ''">{{ order.ShipToInfo.AddrDescription }}</van-row>
                <van-row v-show="order.ShipToInfo.AddrLine1 != ''">{{ order.ShipToInfo.AddrLine1 }}</van-row>
                <van-row v-show="order.ShipToInfo.AddrLine2 != ''">{{ order.ShipToInfo.AddrLine2 }}</van-row>
                <van-row
                  v-show="order.ShipToInfo.AddrCity != '' && order.ShipToInfo.AddrProv != '' && order.ShipToInfo.AddrPostalCode != ''"
                  >{{ order.ShipToInfo.AddrCity }} {{ order.ShipToInfo.AddrProv }} {{ order.ShipToInfo.AddrPostalCode }}</van-row
                >
                <van-row v-show="order.ShipToInfo.AddrPhone != ''">{{ order.ShipToInfo.AddrPhone }}</van-row>
                <van-row v-show="order.ShipToInfo.AddrEMail != ''">{{ order.ShipToInfo.AddrEMail }}</van-row>
              </div>
              <van-row v-show="order.TrackingNumber != ''">{{ $t("order.tracking") }} : {{ order.TrackingNumber }}</van-row>
            </div>
          </div>
        </van-col>
      </van-row>
    </div>
  </ion-app>
</template>

<script>
export default {
  data() {
    return {
      orders: null,
    };
  },

  mounted() {
    this.getOrders();
  },

  computed: {
    member() {
      return this.$store.state.member;
    },
  },

  methods: {
    getOrders() {
      let obj = {
        AppVersion: this.$version,
        SessionId: this.member.SessionId,
        SessionToken: this.member.SessionToken,
      };
      this.$ajax2
        .post("GetOrders", obj, this.$ajaxHeader)
        .then((rpdata) => {
          if (rpdata.data.meta.code == "200") {
            this.orders = rpdata.data.data;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },

    timestampToLocaleString(timestamp) {
      let localeTime = timestamp;
      try {
        let nTime = timestamp;
        let parts = timestamp.split(/[-: .+]/);
        if (parts.length == 8) {
          nTime = parts[0] + "/" + parts[1] + "/" + parts[2] + " " + parts[3] + ":" + parts[4] + ":" + parts[5] + "+" + parts[7];
        } else if (parts.length == 7) {
          nTime = parts[0] + "/" + parts[1] + "/" + parts[2] + " " + parts[3] + ":" + parts[4] + ":" + parts[5] + "+" + parts[6];
        }

        localeTime = new Date(nTime).toLocaleString();
      } catch (err) {
        if (isDevMode()) console.log(err);
      }

      return localeTime;
    },
  },
};
</script>

<style>
.order {
  width: 100%;
}

.order-header {
  margin-bottom: 10px;
  background-color: #5f8dff;
  color: white;
  padding: 10px;
}

.order-product {
  padding: 5px 10px;
}

.product-ext {
  text-align: right;
}

.order-total {
  padding: 10px;
}

.order-total .van-row {
  padding: 5px 0px;
}

.order-total .total .t-value {
  font-weight: bold;
}

.t-title {
  text-align: right;
  font-weight: bold;
}

.t-value {
  text-align: right;
}

.order-shipping {
  padding: 10px;
}

.order-shipping .shipto-title {
  font-weight: bold;
}

.ship-to-address {
  padding: 5px 10px;
}

.ship-to-address .van-row {
  padding: 2px 0px;
}
</style>
